<template>
  <div class="grid grid-cols-1 gap-2 overflow-x-auto xl:grid-cols-2">
    <div class="stats stats-vertical bg-base-100 mb-2 w-full shadow">
      <div class="stat">
        <div class="stat-title text-sm">
          <i class="fa-brands fa-windows text-base-content/50"></i>
          Hệ điều hành
        </div>
        <div class="stat-value text-xl">
          {{ client_detail_store.client_detail?.os }}
        </div>
      </div>
      <div class="stat">
        <div class="stat-title text-sm">
          <i class="fa-solid fa-microchip text-base-content/50"></i>
          Bộ xử lý
        </div>
        <div class="stat-value text-xl">
          {{ client_detail_store.client_detail?.cpu }}
        </div>
      </div>
      <div class="stat">
        <div class="stat-title text-sm">
          <i class="fa-solid fa-memory text-base-content/50"></i>
          Bộ nhớ
        </div>
        <div class="stat-value text-xl">
          {{ Math.round(Number(client_detail_store.client_detail?.memory)) }} GB
        </div>
      </div>
      <div class="stat">
        <div class="stat-title text-sm">
          <i class="fa-solid fa-user text-base-content/50"></i>
          Người dùng
        </div>
        <div class="stat-value text-xl">
          {{ client_detail_store.client_detail?.username }}
        </div>
      </div>
      <div class="stat">
        <div class="stat-title text-sm">
          <i class="fa-solid fa-clock text-base-content/50"></i>
          Lần kết nối cuối cùng
        </div>
        <div class="stat-value text-xl">
          {{
            dayjs(client_detail_store.client_detail?.last_connection).fromNow()
          }}
        </div>
      </div>
      <div class="stat">
        <div class="stat-title text-sm">
          <i class="fa-solid fa-code-branch"></i>
          Phiên bản
        </div>
        <div class="stat-value flex justify-between text-xl">
          {{ client_detail_store.client_detail?.version }}
        </div>
      </div>
    </div>

    <div
      v-if="client_detail_store.client_detail?.privileges && Object.values(client_detail_store.client_detail.privileges).some((v) => v)"
      class="bg-base-100 mb-2 shadow"
    >
      <table class="table-md table">
        <thead>
          <tr>
            <th colspan="2" class="border-b-0 py-2 text-left font-bold">
              <div class="flex items-center gap-2">
                <i class="fa-solid fa-user-shield text-base-content/50"></i>
                Quyền (Privileges)
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(label, key) in privilege_labels" :key="String(key)">
            <tr v-if="client_detail_store.client_detail?.privileges?.[key]">
              <th class="text-base-content/80">{{ label }}:</th>
              <td>
                <span style="white-space: pre-wrap;">{{ client_detail_store.client_detail.privileges[key] }}</span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <ElevateButton />

    <div v-if="client_detail_store.client_detail?.network?.length">
      <table
        v-for="(adapter, index) in client_detail_store.client_detail.network"
        :key="index"
        class="table-md bg-base-100 mb-2 table shadow"
      >
        <tbody>
          <tr>
            <th
              colspan="2"
              class="bg-base-200! border-b-0 py-2 text-left font-bold"
            >
              <div class="flex items-center gap-2">
                <i class="fa-solid fa-network-wired text-base-content/50"></i>
                <span>
                  Network Adapter {{ index + 1 }}:
                  {{ adapter.description }}
                </span>
              </div>
            </th>
          </tr>
          <tr v-if="adapter.physical_address">
            <th class="text-base-content/80">MAC:</th>
            <td>
              <span>{{ adapter.physical_address }}</span>
            </td>
          </tr>

          <tr v-if="adapter.ipv4_address">
            <th class="text-base-content/80">IPv4:</th>
            <td>
              <span>{{ adapter.ipv4_address }}</span>
            </td>
          </tr>

          <tr v-if="adapter.ipv6_address">
            <th class="text-base-content/80">IPv6:</th>
            <td>
              <span>{{ adapter.ipv6_address }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import { use_client_detail } from "./useClientDetail";
import type { client_privileges } from "./index";
import ElevateButton from "./ElevateButton.vue";

const client_detail_store = use_client_detail();

const privilege_labels: Record<keyof client_privileges, string> = {
  sid: "SID",
  domain: "Domain",
  elevation: "Elevation",
  elevation_type: "Elevation type",
  integrity_level: "Integrity level",
  privileges: "Privileges",
  permission: "Permission",
};
</script>
